/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 /*(model, fieldName, label, type, html_options, prefix)*/ ;
__p += '\n' +
((__t = ( form_group_for(model, 'Username', 'Username', 'text', {input: {'class': 'uname', 'aria-describedby': 'usernameBlock'}, after: '<span class="help-block username-block" id="usernameBlock"></span>'}) )) == null ? '' : __t) +
'\n' +
((__t = ( form_group_for(model, 'PrimaryName', 'First Name', 'text'))) == null ? '' : __t) +
'\n' +
((__t = ( form_group_for(model, 'SecondaryName', 'Last Name', 'text'))) == null ? '' : __t) +
'\n' +
((__t = ( form_group_for(model, 'EmailAddress', 'Email', 'email'))) == null ? '' : __t) +
'\n' +
((__t = ( form_group_for(model, 'PhoneNumber', 'Phone Number', 'text'))) == null ? '' : __t) +
'\n' +
((__t = ( form_group_for(model, 'Extension', 'Extension', 'text'))) == null ? '' : __t) +
'\n\n';
 if(isAdmin){;
__p += '\n	' +
((__t = ( form_group_for(model, 'Organization', 'Organization', organizations, {
		input: {'class': 'user_org'}
	}))) == null ? '' : __t) +
'\n';
 } else {;
__p += '\n	' +
((__t = ( form_group_for(model, 'Organization', '', 'hidden'))) == null ? '' : __t) +
'\n';
 };
__p += '\n\n';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/admin/users/Create.ejs
// module id = 870
// module chunks = 1